import React, {
  forwardRef, memo, useMemo, useCallback,
} from 'react';
import { func } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import l18n from '../../shared/strings';
import Logger from '../../services/Logger';
import { isUploadStarted, requiredFields as requiredCustomFieldsSelector } from '../../store/import/selectors';
import { addToListField, removeFromListField } from '../../store/import/actions';
import DetailsBlock from '../DetailsBlock';
import AssigneesDropdown from '../assigneesDropdown';
import { panelsVisibilityShape, getIndicator } from './helpers';

const Assignees = forwardRef(({ panelsVisibility, toggleVisibility }, ref) => {
  const dispatch = useDispatch();

  const requiredFields = useSelector(requiredCustomFieldsSelector);
  const numberOfSelectedFiles = useSelector((state) => state.import.selected.length);
  const editPermission = useSelector((state) => Boolean(state.import.permissions.editAssetAssignees));
  const error = useSelector((state) => state.import.errors.assignees);
  const disabled = useSelector(isUploadStarted);
  const assignees = useSelector((state) => state.import.fields.assignees);

  const indicator = useMemo(() => getIndicator('assignees', requiredFields), [requiredFields]);

  const handleBlur = useCallback(() => {
    Logger.log('User', 'UploadPanelAssignUsers', {
      assignees_number: assignees.length,
      assets_number: numberOfSelectedFiles,
    });
  }, [assignees, numberOfSelectedFiles]);

  const handleSelect = useCallback((items) => {
    const value = Array.isArray(items) ? items : [items];
    dispatch(addToListField({ title: 'assignees', value }));
  }, [dispatch]);

  const handleDeselect = useCallback(({ _id }) => {
    dispatch(removeFromListField({ title: 'assignees', _id }));
  }, [dispatch]);

  return (
    <DetailsBlock
      dataQa="assignees"
      ref={ref}
      detailsPanelVisibility={panelsVisibility}
      toggleVisibility={toggleVisibility}
      blockName="importAssigneesVisibility"
      blockTitle={l18n.DETAILS.textAssignees}
      indicator={indicator}
      error={error}
      errorHighlight
      openByDefault={error || indicator !== null}
    >
      <div className="importFieldItem">
        <AssigneesDropdown
          placeholder={l18n.ASSING_USER.placeholder}
          icon="avatar"
          placeholderIcon="emptyAvatar"
          title={l18n.ASSING_USER.title}
          filterText={l18n.ASSING_USER.filterText}
          checkedItems={assignees}
          onCheckedHandler={handleSelect}
          onUncheckedHandler={handleDeselect}
          onBlur={handleBlur}
          disabled={disabled}
          readOnly={!editPermission}
          error={error}
        />
      </div>
    </DetailsBlock>
  );
});

Assignees.propTypes = {
  panelsVisibility: panelsVisibilityShape.isRequired,
  toggleVisibility: func.isRequired,
};

export default memo(Assignees);
